module.exports = __webpack_public_path__ + "img/1.95a67817.png";